import React from "react";
import { Dropdown, Space } from "antd";
import { BsThreeDotsVertical } from "react-icons/bs";
import { Link } from "react-router-dom";

const FeaturesBar = ({ name, email, dropdownItems, link }) => {
  return (
    <Link to={link} className="features-bar">
      <div className="features-bar-content">
        <h5>{name}</h5>
        <h6>{email}</h6>
      </div>
      {/* <Dropdown
        trigger={["click"]}
        menu={{
          items: dropdownItems,
        }}
        placement="bottomRight"
      >
        <a onClick={(e) => e.preventDefault()}>
          <Space>
            <BsThreeDotsVertical />
          </Space>
        </a>
      </Dropdown> */}
    </Link>
  );
};

export default FeaturesBar;
